var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "list"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m26 3h-20a3 3 0 0 0 -3 3v20a3 3 0 0 0 3 3h20a3 3 0 0 0 3-3v-20a3 3 0 0 0 -3-3zm-18 11h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1-1v-2a1 1 0 0 1 1-1zm-1-3v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1-1zm1 9h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1-1v-2a1 1 0 0 1 1-1zm6 1h10a1 1 0 0 1 0 2h-10a1 1 0 0 1 0-2zm-1-5a1 1 0 0 1 1-1h10a1 1 0 0 1 0 2h-10a1 1 0 0 1 -1-1zm11-5h-10a1 1 0 0 1 0-2h10a1 1 0 0 1 0 2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.b28c8c4e.svg";
export { ForwardRef as ReactComponent };